<template>
  <tabs-root class="bg-white flex flex-col w-full"
             :default-value="activeTab">
    <tabs-list class="relative shrink-0 flex border-b border-neutral-200">
      <tabs-indicator class="absolute left-0 h-1 bottom-0 w-[--radix-tabs-indicator-size] 
      translate-x-[--radix-tabs-indicator-position] rounded-full transition-[width,transform] duration-300">
        <div class="bg-blue w-full h-full"></div>
      </tabs-indicator>
      <tabs-trigger v-for="(tab, index) in tabs" :key="index"
                    class="bg-white p-6 h-6 flex-1 flex items-center justify-center text-sm leading-none
                          text-neutral select-none  hover:text-blue 
                          data-[state=active]:text-blue data-[state=active]:font-bold outline-none cursor-default"
                    :value="tab.key">
        {{ tab.title }}
      </tabs-trigger>
    </tabs-list>
    <tabs-content v-for="(tab, index) in tabs" :key="index"
                  class="grow bg-white rounded-b-md outline-none"
                  :value="tab.key">
      <slot :name="tab.key"/>
    </tabs-content>
  </tabs-root>
</template>
<script lang="ts" setup>
import { TabsContent, TabsIndicator, TabsList, TabsRoot, TabsTrigger } from 'radix-vue';

defineProps<{
  activeTab: string
  tabs: Tab[]
}>();
</script>
